import { render, staticRenderFns } from "./projects_list_item_leave_modal.vue?vue&type=template&id=33dbe743&vue3"
import script from "./projects_list_item_leave_modal.vue?vue&type=script&lang=js&vue3"
export * from "./projects_list_item_leave_modal.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports